import { motion } from "framer-motion";
import { Card } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import React, { useState, useCallback } from 'react';
import { activities, companies } from '../../../db';

export default function Header() {
  const [showBubble, setShowBubble] = useState(false);
  const currentActivity = activities
    .filter(activity => !activity.endDate)
    .sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0];
  const messages = [
    "Hi!",
    "Hey there!",
    "What's up?",
    "Hello!",
    "Greetings!",
    "Howdy!",
    "Salutations!",
    "Good day!",
    "Nice to see you!",
    "Sup?"
  ];
  const [currentMessage, setCurrentMessage] = useState('');

  const handleClick = useCallback(() => {
    const randomIndex = Math.floor(Math.random() * messages.length);
    setCurrentMessage(messages[randomIndex]);
    setShowBubble(true);
    setTimeout(() => setShowBubble(false), 2000);
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="relative h-[40vh] md:h-[50vh] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-b from-primary/20 to-background z-10" />
      <div className="relative z-20 h-full flex flex-col items-center justify-center p-6">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="mb-8"
        >
          <div className="relative">
            <button 
              onClick={handleClick} 
              className="relative group focus:outline-none"
              aria-label="Profile picture"
            >
              <div 
                className={`absolute left-[-100px] top-1/2 transform -translate-y-1/2 bg-black text-white px-4 py-2 rounded-md z-50 transition-opacity duration-300 ${
                  showBubble ? 'opacity-100' : 'opacity-0'
                }`}
              >
                {currentMessage}
              </div>
              <Avatar className="w-40 h-40">
              <AvatarImage src="/assets/jonas_siebler_profile_pic.jpg" alt="Profile photo" />
              <AvatarFallback>Jonas Siebler</AvatarFallback>
            </Avatar>
            </button>
          </div>
        </motion.div>
        <Card className="bg-background/80 backdrop-blur p-6 max-w-2xl">
          <motion.h1 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
            className="text-3xl md:text-4xl font-bold text-foreground mb-2"
          >
            Jonas Siebler
          </motion.h1>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5 }}
            className="text-lg"
          >
            <h3 className="text-lg text-foreground">{currentActivity?.title}</h3>
          </motion.div>
        </Card>
      </div>
    </motion.div>
  );
}